import clsx from 'clsx';
import { type ReactNode, type MouseEvent } from 'react';
import { Icon } from '../icon/icon.component';
import { type Style, mergeStyle } from './select-option.module.css';

interface Props<T> {
  value?: T;
  label?: string;
  selected?: boolean;
  disabled?: boolean;
  showClearIcon?: boolean;
  children: ReactNode;
  style?: Style;
  onClick?: (value?: T, label?: string) => void;
  onClear?: () => void;
}

export function SelectOption<T>(props: Props<T>) {

  const {
    value,
    label,
    children,
    selected = false,
    disabled = false,
    showClearIcon = true,
    style: customStyle,
    onClick,
    onClear
  } = props;

  const style = mergeStyle(customStyle);

  function handleClick(event?: MouseEvent<HTMLDivElement>) {
    if (onClick && !disabled) {
      onClick(value, label);
      event?.stopPropagation();
    }
  }

  function handleClear(event?: MouseEvent<HTMLDivElement>) {
    if (onClear) onClear();
    event?.stopPropagation();
  }

  return (
    <div 
      className={clsx(
        style.container, 
        selected && style.selected,
        disabled && style.disabled
      )} 
      onClick={handleClick}>
      {children}
      {showClearIcon && selected && 
        <Icon 
          className={style.icon} 
          icon='clear'
          onClick={handleClear}/>
      }
    </div>
  );
}
